import React from 'react';
import { Link } from 'react-router-dom';

const SHOWCASE_CARDS = [
    { name: 'Tony Gwynn', rating: 72, rarity: 'silver', art: '/img/card/1995-base.png' },
    { name: 'Ken Griffey Jr', rating: 79, rarity: 'silver', art: '/img/card/1984-base.png', variation: 'chrome' },
    { name: 'Mickey Mantle', rating: 99, rarity: 'uranium', art: '/img/card/1961-base.png', variation: 'fire' },
    { name: 'Shohei Ohtani', rating: 95, rarity: 'titanium', art: '/img/card/2025-base.png', variation: 'refractor' },
    { name: 'Mike Trout', rating: 99, rarity: 'uranium', art: '/img/card/2021-base.png', variation: 'radioactive' },
];

const LandingPage = () => (
    <>
        <section className="landing-hero">
            <h1>Uranium Baseball</h1>
            <p className="landing-hook">Open your first packs now!</p>
            <Link to="/register" className="landing-cta">
                Start Playing
            </Link>
            <div className="landing-card-fan">
                {SHOWCASE_CARDS.map((card, i) => (
                    <div key={i} className={`fan-card${card.variation ? ` fan-var-${card.variation}` : ''}`}>
                        <div className="fan-card-art" style={{ backgroundImage: `url(${card.art})` }} />
                        {card.variation && <span className="fan-var-label">{card.variation}</span>}
                        <div className="fan-card-info">
                            <span className={`fan-card-rating rating-${card.rarity}`}>{card.rating}</span>
                            <span className="fan-card-name">{card.name}</span>
                        </div>
                    </div>
                ))}
            </div>
        </section>

        <section className="landing-below-fold">
            <div className="landing-steps">
                <span className="landing-step-label">Collect</span>
                <span className="landing-step-arrow">&rarr;</span>
                <span className="landing-step-label">Build</span>
                <span className="landing-step-arrow">&rarr;</span>
                <span className="landing-step-label">Play</span>
            </div>
            <Link to="/register" className="landing-cta-bottom">
                Start Playing
            </Link>
            <span className="landing-free-note">100% free</span>
        </section>
    </>
);

export default LandingPage;
